/** Payload when the player gained at least one level after XP from a quiz/PvP attempt. */
export interface LevelUpCelebrationPayload {
  oldLevel: number;
  newLevel: number;
}

export interface QuizLevelUpDetectInput {
  newLevel?: number | null;
  tooManySkips?: boolean;
  earnedXP?: number | null;
}

/**
 * Detects a level-up from a solo quiz finish response.
 * Compares API `newLevel` with the level captured before the attempt (ref from profile on mount).
 */
export function detectQuizLevelUp(
  levelBeforeQuiz: number | null | undefined,
  response: QuizLevelUpDetectInput
): LevelUpCelebrationPayload | null {
  if (response.tooManySkips) return null;
  const newLevel = response.newLevel;
  if (newLevel == null || newLevel < 1) return null;
  if (levelBeforeQuiz == null) return null;
  if (newLevel > levelBeforeQuiz) {
    return { oldLevel: levelBeforeQuiz, newLevel };
  }
  return null;
}

/** PvP participant row after room resolve. */
export function detectPvpParticipantLevelUp(
  levelBeforeMatch: number | null | undefined,
  participant: { newLevel?: number; earnedXP?: number } | undefined
): LevelUpCelebrationPayload | null {
  if (!participant) return null;
  return detectQuizLevelUp(levelBeforeMatch, {
    newLevel: participant.newLevel,
    earnedXP: participant.earnedXP,
  });
}
